
import React, { Component } from 'react';
import { Modal, Input, Divider, Row, Col } from 'antd';

import messager from '../../ui/messager';
import http from '../../../axios/http';
import { moneyToCapital, moneyFormat, dateUtil } from '../../../util/util.js';

const taxTypeArray = {
    '1': '个人',
    '2': '个体户',
    '3': '有限责任公司',
    '4': '有限责任公司',
};

class TaxRedRush extends Component {

    state = {
        ticketItem: [{}, {}, {}, {}, {}],
        ticketData: {},
        queryTaxNo: '',
        oldTaxNo: '',
        newTaxNo: '',
    }

    print = () => {
        let ticketData = this.state.ticketData;
        if (ticketData.id == null ) {
            messager.notify("请先查询要红冲的税票！");
            return;
        }
        if (ticketData.taxNo == null ||  ticketData.taxNo === "") {
            messager.notify("请先输入新的税票号码！");
            return;
        }
        //保存数据到数据库
        this.savePrintInfo();

        var printHtml = window.document.getElementById('red_rush_print_div').innerHTML;
        var newWindow = window.open("", "print");
        newWindow.document.body.innerHTML = printHtml;
        newWindow.window.print();
        newWindow.window.close();
    };

    savePrintInfo = () => {
        let data = {};
        let ticketData = this.state.ticketData;
        data.id = ticketData.id;
        data.oldTaxNo = this.state.oldTaxNo;
        data.newTaxNo = this.state.newTaxNo;
        data.taxDuration = this.state.ticketItem[0].taxDuration;
        http.post({
            url: '/taxTicket/saveTaxTicketRedRush',
            data: data,
            success: (res) => {
                if (this.props.successCallback) {
                    this.props.successCallback(this.props.queryData);
                }
                this.closeModal();
            }
        });
    }

    //获取已经打印的税票进行红冲操作
    searchTaxTicket = (value) => {
        if (value == null || value === "") {
            messager.notify("税票号不能为空！");
            return;
        }
        http.get({
            url: '/taxTicket/findTaxTicket',
            data: { "taxNo": value },
            success: (res) => {
                let date = new Date();
                let year = date.getFullYear();
                let month = date.getMonth() + 1;
                month = month < 10 ? ('0' + month) : month;
                let day = date.getDate();
                day = day < 10 ? ('0' + day) : day;
                let editData = res["ticket"];
                let ticket = {};
                //基本信息
                ticket.year = year;
                ticket.month = month;
                ticket.day = day;
                ticket.id = editData.id;
                ticket.taxAuthorities = editData.taxAuthorities;
                ticket.amountCapital = moneyToCapital(ticket.totalTaxAmount);
                ticket.filler = editData.filler;
                ticket.plateNo = editData.plateNo;
                ticket.amount = editData.amount;
                if (value === editData["sellerTaxNo"]) {
                    ticket.totalTaxAmount = -editData.sellerTaxAmount;
                    ticket.taxNo = this.state.newTaxNo;
                    ticket.taxType = taxTypeArray[editData.sellerType];
                    ticket.creditNo = editData.sellerCreditNo;
                    ticket.name = editData.sellerName;
                    ticket.addr = editData.sellerAddr;
                } else {
                    ticket.totalTaxAmount = -editData.buyerTaxAmount;
                    ticket.taxNo = this.state.newTaxNo;
                    ticket.taxType = taxTypeArray[editData.buyerType];
                    ticket.creditNo = editData.buyerCreditNo;
                    ticket.name = editData.buyerName;
                    ticket.addr = editData.buyerAddr;
                }
                let taxDuration = dateUtil.getCurrentMonthFirstDay() + "-" + dateUtil.getCurrentMonthLastDay();
                let item = res["item"];
                item.forEach((d) => {
                    d.taxDuration = taxDuration;
                    d.taxAmount = -d.taxAmount;
                });
                if (item.length === 1) {
                    item.push({});
                    item.push({});
                    item.push({});
                    item.push({});
                }
                this.setState({
                    ticketData: ticket,
                    ticketItem: item,
                    oldTaxNo: value
                });
            }
        });
    }

    oldTaxNoChange = (event) => {
        let value = event.target.value;
        this.setState({ queryTaxNo: value });
    }

    newTaxNoChange = (event) => {
        let value = event.target.value;
        let ticketData = this.state.ticketData;
        ticketData.taxNo = value;
        this.setState({ ticketData: ticketData, newTaxNo: value });
    }

    closeModal = () =>{
        this.setState({
            ticketItem: [{}, {}, {}, {}, {}],
            ticketData: {},
            oldTaxNo: '',
            queryTaxNo: '',
            newTaxNo: ''
        });

        this.props.onCancel();
    }

    render() {
        const { visible} = this.props;
        const data = this.state.ticketData;
        const item = this.state.ticketItem;
        return (
            <Modal
                width={850}
                visible={visible}
                title="税票红冲"
                okText="打印"
                cancelText="取消"
                maskClosable={false}
                onCancel={this.closeModal}
                onOk={this.print}
            >
                <Row>
                    <Col span={12}>
                        <Input.Search
                            placeholder="税票号"
                            onSearch={this.searchTaxTicket}
                            value={this.state.queryTaxNo}
                            onChange={this.oldTaxNoChange}
                            enterButton
                            style={{ width: 300 }}
                        />
                    </Col>
                    <Col span={12}>
                        <Input
                            placeholder="新税票号"
                            onChange={this.newTaxNoChange}
                            value={this.state.newTaxNo}
                            style={{ width: 300 }}
                        />
                    </Col>
                </Row>
                <Divider orientation="left">税票</Divider>
                <style>
                    {`
                        .print-div{width:795px !important;}
                        .text-right{text-align: right;}
                        .text-no-print{color: #b94343; display: inline !important;}
                        .tax-no{color: #ff0000; font-size: 14px;}
                        .none-border-table{width:100%;}
                        .border-table{width:100%;}
                        .border-table td{border: 1px solid #b94343;border-bottom:none;}
                        .top-border-table{width:100%;border: 1px solid #b94343;}
                        .top-border-table tr:first-child>td{border: 1px solid #b94343;}
                        .top-border-table tr:last-child>td{border: 1px solid #b94343;}
                        .top-border-table td{border-right: 1px solid #b94343;}
                        .right-border-table{border: 1px solid #b94343; border-top: none;}
                        .right-border-table tr>td:nth-child(-n+3){border-right: 1px solid #b94343;}
                        .td-no-print{height: 33px !important;}
                        .print-div{margin: 0 !important;}
                        .border-table td{text-align:center !important;}
                        .top-border-table td{text-align:center !important; }
                        .right-border-table td{text-align:center !important;}
                        .align-left-table td{text-align: left !important;}
                        .top-border-table .align-left-td{text-align: left !important;}
                        .text-print{font-size: 12px !important; font-weight: normal !important;}
                    `}
                </style>
                <div id="red_rush_print_div">
                    <style>
                        {`
                            .print-div{width:795px; font-size:12px !important; font-family:Simsun;margin: 0;}
                            .print-div td{ padding: 0; }
                            .none-border-table td{text-align:left;}
                            .border-table td{text-align:center;}
                            .top-border-table td{text-align:center; }
                            .right-border-table td{text-align:center;}
                            .text-no-print{display: none;}
                            .text-print{}
                            .td-no-print{height: 30px}
                            .none-border-table,
                            .border-table,
                            .top-border-table,
                            .right-border-table
                            {width:100%;}
                        `}
                    </style>
                    <div className="print-div">
                        <div>
                            <div className="text-right"><span className="text-no-print">（191）厦税现</span><span className="tax-no text-no-print">{data.taxNo}</span></div>
                        </div>
                        <table className="none-border-table ">
                            <tbody>
                                <tr>
                                    <td style={{ width: '100px' }}><span className="text-no-print">登记注册类型：</span></td>
                                    <td style={{ width: '165px', fontSize: '14px', fontWeight: 'bold', fontFamily: "Simsun" }}><span className="text-print">{data.taxType}</span></td>
                                    <td style={{ width: '70px' }}><span className="text-no-print">填发日期：</span></td>
                                    <td style={{ width: '35px', textAlign: 'center', fontSize: '14px', fontWeight: 'bold', fontFamily: "Simsun" }}><span className="text-print">{data.year}</span></td>
                                    <td style={{ width: '15px' }}><span className="text-no-print">年</span></td>
                                    <td style={{ width: '35px', textAlign: 'center', fontSize: '14px', fontWeight: 'bold', fontFamily: "Simsun" }}><span className="text-print">{data.month}</span></td>
                                    <td style={{ width: '15px' }}><span className="text-no-print">月</span></td>
                                    <td style={{ width: '35px', textAlign: 'center', fontSize: '14px', fontWeight: 'bold', fontFamily: "Simsun" }}><span className="text-print">{data.day}</span></td>
                                    <td style={{ width: '15px' }}><span className="text-no-print">日</span></td>
                                    <td style={{ width: '100px', textAlign: 'right' }}><span className="text-no-print">税务机关：</span></td>
                                    <td style={{ width: '210px', textIndent: '5px', fontSize: '12px', fontWeight: 'bold', fontFamily: "Simsun" }}><span className="text-print">{data.taxAuthorities}</span></td>
                                </tr>
                            </tbody>
                        </table>
                        <table className="border-table align-left-table">
                            <tbody>
                                <tr>
                                    <td style={{ width: '86px', height: '27px' }}><span className="text-no-print">纳税人识别号</span></td>
                                    <td style={{ width: '291px', textAlign: 'left', textIndent: '10px', fontSize: '14px', fontWeight: 'bold', fontFamily: "Simsun" }}><span className="text-print">{data.creditNo}</span></td>
                                    <td style={{ width: '81px' }}><span className="text-no-print">纳税人名称</span></td>
                                    <td style={{ width: '332px', textAlign: 'left', textIndent: '10px', fontSize: '14px', fontWeight: 'bold', fontFamily: "Simsun" }}><span className="text-print">{data.name}</span></td>
                                </tr>
                                <tr>
                                    <td style={{ height: '27px' }}><span className="text-no-print">地址</span></td>
                                    <td colSpan="3" style={{ textAlign: 'left', textIndent: '10px', fontSize: '14px', fontWeight: 'bold', fontFamily: "Simsun" }}><span className="text-print">{data.addr}</span></td>
                                </tr>
                            </tbody>
                        </table>
                        <table className="top-border-table">
                            <tbody>
                                <tr>
                                    <td colSpan="2" style={{ width: '120px' }} className="td-no-print"><span className="text-no-print">税种</span></td>
                                    <td style={{ width: '140px' }}><span className="text-no-print">品目名称</span></td>
                                    <td style={{ width: '75px' }}><span className="text-no-print">课税数量</span></td>
                                    <td style={{ width: '75px' }}><span className="text-no-print">计税金额或销售收入</span></td>
                                    <td style={{ width: '60px' }}><span className="text-no-print">税率或单位税额</span></td>
                                    <td style={{ width: '125px' }}><span className="text-no-print">税款所属时期</span></td>
                                    <td style={{ width: '90px' }}><span className="text-no-print">已缴或扣除额</span></td>
                                    <td style={{ width: '110px' }}><span className="text-no-print">实缴金额</span></td>
                                </tr>
                                {item.map((d, index) => (
                                    <tr key={index}>
                                        <td colSpan="2" className="text-print" style={{ height: '38px', textAlign: 'left', fontSize: '14px', fontWeight: 'bold', fontFamily: "Simsun" }}>{d.taxCategory}</td>
                                        <td className="text-print" style={{ paddingRight: '0px', fontSize: '14px', fontWeight: 'bold', fontFamily: "Simsun" }}>{d.itemName}</td>
                                        <td className="text-print" style={{ paddingRight: '0px', fontSize: '14px', fontWeight: 'bold', fontFamily: "Simsun" }}>{d.taxationAmount}</td>
                                        <td className="text-print" style={{ paddingRight: '0px', fontSize: '14px', fontWeight: 'bold', fontFamily: "Simsun" }}>{moneyFormat(d.taxableAmount)}</td>
                                        <td className="text-print" style={{ fontSize: '14px', fontWeight: 'bold', fontFamily: "Simsun" }}>{d.taxRate}</td>
                                        <td className="text-print" style={{ fontSize: '14px', fontWeight: 'bold', fontFamily: "Simsun" }}>{d.taxDuration}</td>
                                        <td></td>
                                        <td className="text-print" style={{ textAlign: 'right', fontSize: '14px', fontWeight: 'bold', fontFamily: "Simsun" }}>{moneyFormat(d.taxAmount)}</td>
                                    </tr>
                                ))}
                                <tr>
                                    <td style={{ width: '65px', height: '30px', paddingTop: '0px' }}><span className="text-no-print">金额合计</span></td>
                                    <td style={{ width: '55px', borderRight: 'none', paddingTop: '0px' }}><span className="text-no-print">（大写）</span></td>
                                    <td colSpan="6" style={{ borderLeft: 'none', textAlign: 'left', paddingTop: '0px', fontSize: '14px', fontWeight: 'bold', fontFamily: "Simsun" }} className='align-left-td'><span className="text-print">{data.amountCapital}</span></td>
                                    <td style={{ textAlign: 'right', paddingTop: '0px', fontSize: '14px', fontWeight: 'bold', fontFamily: "Simsun" }}>
                                        <span className="text-print" >{moneyFormat(data.totalTaxAmount)}</span>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <table className="right-border-table">
                            <tbody>
                                <tr>
                                    <td style={{ width: '132px', height: '30px' }}></td>
                                    <td style={{ width: '132px' }}></td>
                                    <td style={{ width: '132px' }}></td>
                                    <td style={{ width: '30px' }}><span className="text-no-print">备注</span></td>
                                    <td style={{ width: '259px' }}></td>
                                    <td style={{ width: '110px' }}></td>
                                </tr>
                                <tr>
                                    <td style={{ height: '30px' }}><span className="text-no-print">税务机关</span></td>
                                    <td><span className="text-no-print">代征单位</span></td>
                                    <td><span className="text-no-print">填票人</span></td>
                                    <td></td>
                                    <td style={{ fontSize: '14px', fontWeight: 'bold', fontFamily: "Simsun" }}><span className="text-print">{data.plateNo}</span></td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <td style={{ height: '30px' }}><span className="text-no-print">（盖章）</span></td>
                                    <td><span className="text-no-print">（盖章）</span></td>
                                    <td style={{ fontSize: '14px', fontWeight: 'bold', fontFamily: "Simsun" }}><span className="text-print">{data.filler}</span></td>
                                    <td></td>
                                    <td></td>
                                    <td style={{ textAlign: 'right', fontSize: '14px', fontWeight: 'bold', fontFamily: "Simsun" }}><span className="text-print">{moneyFormat(data.amount)}</span></td>
                                </tr>
                                <tr>
                                    <td style={{ height: '17px' }}></td>
                                    <td></td><td></td><td></td><td></td><td></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </Modal>
        );
    }
}


export default TaxRedRush;